<template>
  <v-container>
    <page-title title="Result overview" />
    <v-spacer></v-spacer>

    <!-----------the result statistics--------------->
    <v-row justify="space-between" class="mb-7">
      <v-col cols="12" sm="4">
        <v-progress-circular :value="percentage" :width="15" :size="120" :color="color" :rotate="360" class="my-5"
          :indeterminate="loading">
          <strong>
            {{
                !percentage || percentage >= 0 ? percentage : "computing"
            }}%</strong>
        </v-progress-circular>
        <div class="text--secondary " style="max-width: 80%;">
          You attempted <strong>{{ score }}</strong> question correctly out of <strong>50</strong> in total
          <!-- <strong> {{ correction.length }}</strong> out of <strong>50</strong>, -->

          amounting to <strong> {{ percentage }}%</strong>
          {{ percentage > 50 ? "😊" : "😟" }}
        </div>
      </v-col>

      <!----- more details ------->
      <!--  <v-col cols="12" sm="4" class="d-flex justify-center align-center d-none">
        <v-btn outlined text class="ma-2" :to="{ name: 'select-subject' }">
          Retry
          <v-icon right small>mdi-refresh</v-icon>
        </v-btn>
        <v-btn elevation="0" outlined color="var(--red)" class="ma-2" :to="{ name: 'dashboard' }">
          Exit
          <v-icon right small>mdi-logout-variant</v-icon>
        </v-btn>
        <v-btn elevation="0" outlined color="success" class="ma-2" @click="showSolution = !showSolution">
          <span v-if="!showSolution">Solution</span>
          <span v-else>Hide Solution</span>
          <v-icon right small>mdi-check</v-icon>
        </v-btn>
      </v-col> -->
    </v-row>
    <v-divider class="mb-7"></v-divider> <v-spacer></v-spacer>

    <!--------correction------------>
    <transition-group mode="out-in" enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut">
      <div v-if="showSolution" key="title" class="mt-2">
        <page-title title="solution" />
        <v-list class="mt-4" v-for="(solution, index) in solutions" :key="solution.id">
          <!------show the questions indexes, on click of each, goto the clicked index--->

          <v-list-item class="text--secondary">
            <!-- <strong class="d-block-inline mr-1 d-nne">{{ index + 1 }}.</strong> -->
            <div id="question" v-html="`<strong class=mr-2>${index + 1}. </strong>` + solution.question"></div>
          </v-list-item>

          <!-----------options-------->
          <div v-for="(key, value) in (Object.entries(solution.options))" :key=value :value="option" text
            class="d-block my-2 ml-3 " :class="{
            
              'correct-answer':
                key[0] === solution.answer,
            }">
              <!-- 'wrong-answer':
              solution.answer !==
              solution.userSelection, -->
            <!-- {{ solution.userSelection }} -->
            <!-- <span v-html="key[0] + '. ' + key[1]"></span> -->
            {{ key[1] }}
          </div>



          <v-radio-group class="d-none">
            <v-radio v-for="option in Object.values(solution.options)" :key="option" :value="option" disabled :class="{
              'wrong-answer':
                Object.values(solution.options).indexOf(option) ===
                solution.userSelection,
              'correct-answer':
                Object.values(solution.options).indexOf(option) ===
                solution.answer,
            }">
              <template v-slot:label>
                <span :class="{
                  'wrong-answer':
                    Object.values(solution.options).indexOf(option) ===
                    solution.userSelect,
                  'correct-answer':
                    Object.values(solution.options).indexOf(option) ===
                    solution.answer,
                }">{{ option }}
                </span></template>
            </v-radio>
          </v-radio-group>
          <!-- {{ solution }} -->
          <!---------------show the options here---------------->
        </v-list>
      </div>
    </transition-group>
  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
import axios from "axios";
export default {
  components: {
    PageTitle,
  },
  data: () => ({
    val: null,
    score: null, //the user score over total number of attempted questions
    percentage: null, //the user score as percentage
    totalAttemptedQuestions: null, //the total number of questions the user attempted
    idOfAttemptedQuestion: null, //the id of attempted questions
    loading: false, //loader bindings
    totalQuestionFromServer: null, //total number of questions generated at the server
    correction: null, //correction of attempted quiz
    showSolution: true,
  }),
  created() {
    //get the result
    this.getQuizResult();
  },
  computed: {
    color() {
      if (this.percentage == null) {
        return "var(--purple)";
      } else if (this.percentage <= 35) {
        return "var(--red)";
      } else if (this.percentage > 35 && this.percentage <= 69) {
        return "var(--yellow)";
      } else return "green";
    },

    //compute the correction into something useable
    solutions() {
      let corrections = this.correction;
      let _retn = [];

      for (const index in corrections) {
        const {
          option_a,
          option_b,
          option_c,
          option_d,
          question,
          userSelection,
          answer,
        } = corrections[index];
        // const options = [option_a, option_b, option_c, option_d];
        const options = { 0: option_a, 1: option_b, 2: option_c, 3: option_d };

        _retn.push({ question, userSelection, options, answer });
      }
      return _retn;
    },
  },
  methods: {
    //submit
    async getQuizResult() {
      //first the the test meta data persisted in the local storage
      const attemptedQuestionsMetaData = JSON.parse(
        localStorage.getItem("attemptedQuestionsMetaData")
      );

      // console.log(attemptedQuestionsMetaData);
      const { data: response } = await axios.post(
        "/questions/mark-exam",
        attemptedQuestionsMetaData
      );
      //once the response is received, destructure it into the application then stope loading process
      if (response.data) {
        this.loading = false;
        const {
          score,
          totalAttemptedQuestions,
          idOfAttemptedQuestion,
          totalQuestionFromServer,
          correction,
        } = response.data;

        const percentage = score / 50
        console.log({
          score,
          totalAttemptedQuestions,
          idOfAttemptedQuestion,
          totalQuestionFromServer,
          correction,
        });

        //destruct the data into the application
        this.score = score;
        this.percentage = percentage;
        this.totalAttemptedQuestions = totalAttemptedQuestions;
        this.idOfAttemptedQuestion = idOfAttemptedQuestion;
        this.totalQuestionFromServer = totalQuestionFromServer;
        this.correction = correction;
        //finally remove the data form the local storage
        //  localStorage.removeItem("attemptedQuestionsMetaData")
        // console.log(correction);
      }
    },
  },
};
</script>

<style scoped>
.cc {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.wrong-answer {
  color: var(--red);
}

.correct-answer {
  color: green;
}
</style>